import { createContext } from 'react'

export const unityPropsContext = createContext({
  lang: 'fr',
  bfsIdParamName: 'gemeinde',
  title: 'Wie gross ist der Anteil der Personen, die …',
  trueProportionLegend: 'Bonne réponse',
  estimatedProportionLegend: 'Moyenne des réponses ',
  municipalityIntroText:
    'Und wie gut kennen Sie Ihre Mitmenschen in Ihrer Gemeinde? Bei den folgenden Fragen müssen Sie immer zweimal schätzen: einmal auf nationaler Ebene für die Schweiz, und einmal für Ihre Gemeinde. Wählen Sie dazu, falls nicht bereits geschehen, Ihre Gemeinde im nachfolgenden Suchfeld aus:',
  searchYourMunicipality: 'Suchen Sie Ihre Gemeinde:',
  inYourMunicipality: 'in Ihrer Gemeinde',
  inSwitzerland: 'in der Schweiz',
  chosenMunicipality: 'Ausgewählte Gemeinde:',
  submit: 'Répondre',
  year: 'Année:',
  source: 'Source:',
})
